import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Fade from '@mui/material/Fade';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import { ReactElement } from 'react';
import { HeaderTabButtons } from '../HeaderTabButtons';
interface BottomAppBarProps {
  lightTheme?: boolean;
  bottomBarTrigger?: boolean;
  shouldFade?: boolean;
}
export function BottomAppBar(t0) {
  const $ = _c(19);
  const {
    lightTheme: t1,
    bottomBarTrigger: t2,
    shouldFade: t3
  } = t0;
  const lightTheme = t1 === undefined ? true : t1;
  const bottomBarTrigger = t2 === undefined ? false : t2;
  const shouldFade = t3 === undefined ? false : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      backgroundImage: "linear-gradient(rgb(255 255 255 / 60%), rgb(255 255 255 / 26%))",
      backdropFilter: "blur(20px) brightness(1.1)",
      WebkitBackdropFilter: "blur(20px) brightness(1.1)"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const lightStyles = t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      backgroundImage: "linear-gradient(rgb(0 0 0 / 60%), rgb(0 0 0 / 26%))",
      backdropFilter: "blur(20px) brightness(0.9)",
      WebkitBackdropFilter: "blur(20px) brightness(0.9)"
    };
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const darkStyles = t5;
  const appBarStyles = lightTheme ? lightStyles : darkStyles;
  const t6 = shouldFade ? undefined : "2s";
  let t7;
  if ($[2] !== t6) {
    t7 = {
      transitionDelay: t6,
      transitionDuration: "225ms"
    };
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      exit: 2225
    };
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const t9 = bottomBarTrigger ? "fixed" : "absolute";
  const t10 = bottomBarTrigger ? 1 : 0;
  let t11;
  if ($[5] !== appBarStyles || $[6] !== t10) {
    t11 = {
      content: "' '",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      opacity: t10,
      ...appBarStyles,
      transition: "opacity 0.3s ease"
    };
    $[5] = appBarStyles;
    $[6] = t10;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== t11 || $[9] !== t9) {
    t12 = {
      display: "flex",
      justifyContent: "center",
      height: 80,
      position: t9,
      top: 0,
      width: "100%",
      zIndex: 3,
      background: "transparent",
      "&::before": t11
    };
    $[8] = t11;
    $[9] = t9;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      px: 4,
      color: "text.primary",
      background: "transparent",
      boxShadow: "none"
    };
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Container data-testid="HeaderBottomAppBar" maxWidth="xl" disableGutters={true} sx={t13}><Toolbar disableGutters={true}><Box sx={{
          width: "100%"
        }}><HeaderTabButtons /></Box></Toolbar></Container>;
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] !== t12) {
    t15 = <Stack sx={t12}>{t14}</Stack>;
    $[13] = t12;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  let t16;
  if ($[15] !== shouldFade || $[16] !== t15 || $[17] !== t7) {
    t16 = <Fade appear={false} in={shouldFade} style={t7} timeout={t8}>{t15}</Fade>;
    $[15] = shouldFade;
    $[16] = t15;
    $[17] = t7;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  return t16;
}